
export const levelsSupport = [
    { value: 1, label: 'Nível 1' },
    { value: 2, label: 'Nível 2' },
    { value: 3, label: 'Nível 3' },
    { value: 4, label: 'Nível 4' },
    { value: 5, label: 'Nível 5' },
];


export const getHoursByMinutes = (duration) =>{ 

    if(!duration) return 0;
    if(duration < 60) return `${duration}min`;
    
    const hours = Math.floor(duration / 60); 
    const minutes = duration % 60; 
    return `${hours}h ${minutes}min`; 
}

// Segmento do cliente. tb_clients.type_client espelha o PERFIL_PRODUTO do Gerente
// (0=Automação, 1=Ponto, 2=Assistência, 3=Maker, 4=Site, -1/null=não classificado),
// mas só Automação e Ponto têm contrapartida em tb_frequent_requests.type. Os demais,
// e o cliente sem classificação, devolvem null — e null é lista aberta, não "Automação".
// Comparar o valor direto, sem Number(), porque Number(null) é 0 e classificaria
// como Automação justamente quem não tem tipo.
export const getClientSegment = (typeClient) => {

    if (typeClient === 0 || typeClient === '0') return 'Automação';
    if (typeClient === 1 || typeClient === '1') return 'Ponto';

    return null;
};
